// Long-form SEO content per service. Used by the per-service detail page.
export const SERVICE_DETAILS = {
  "pool-cleaning": {
    keyword: "pool cleaning",
    intro:
      "Professional pool cleaning in Tampa Bay keeps your water clear, healthy, and ready to swim — even through Florida's brutal humidity and afternoon storms.",
    includes: [
      "Skim surface debris, leaves, and bugs",
      "Brush walls, steps, and tile line",
      "Vacuum the pool floor",
      "Empty skimmer and pump baskets",
      "Test and balance chlorine, pH, alkalinity, and stabilizer",
      "Check filter pressure and equipment for issues",
    ],
    why:
      "Regular pool cleaning protects your liner, plaster, tile, and equipment — and prevents the algae blooms that turn pools green overnight.",
  },
  "weekly-pool-service": {
    keyword: "weekly pool service",
    intro:
      "Weekly pool service is the simplest way to keep your Tampa Bay pool spotless year-round. We show up every week, on the same day, and handle everything.",
    includes: [
      "Same-day weekly visits — set schedule",
      "Full cleaning + chemistry balancing each visit",
      "Filter inspection and pressure checks",
      "Salt cell, chlorinator, and pump checks",
      "Email or text reports after every visit",
      "Discounted rates on repairs as a service member",
    ],
    why:
      "Flat-rate weekly pool service is cheaper than DIY chemicals and one-off cleanings — and your pool is always swim-ready when guests show up.",
  },
  "pool-maintenance": {
    keyword: "pool maintenance",
    intro:
      "Comprehensive pool maintenance covers everything your pool needs to keep running — circulation, filtration, sanitation, and equipment health.",
    includes: [
      "Full cleaning service",
      "Filter cleanings and cartridge changes",
      "Pump and motor inspection and service",
      "Salt cell cleaning and calibration",
      "Heater and timer checks",
      "Pre-storm and post-storm pool readiness",
    ],
    why:
      "Proactive pool maintenance is the single best way to extend the life of your equipment, avoid emergency repair bills, and protect the value of your home.",
  },
  "pool-filter-cleaning": {
    keyword: "pool filter cleaning",
    intro:
      "Pool filter cleaning restores flow, water clarity, and pump efficiency. We service every type of filter used in Tampa Bay backyards.",
    includes: [
      "Cartridge filter chemical soak and rinse",
      "Sand filter backwash and media replacement",
      "DE filter teardown, grid rinse, and recharge",
      "O-ring inspection and replacement",
      "Pressure-gauge calibration",
      "Filter housing leak check",
    ],
    why:
      "A clogged pool filter forces the pump to work harder, burns more electricity, and lets contaminants stay in the water. Routine filter cleaning solves it.",
  },
  "pool-pump-cleaning": {
    keyword: "pool pump cleaning",
    intro:
      "Pool pump cleaning and basket service restores quiet, efficient circulation and prevents premature motor failure.",
    includes: [
      "Pump basket cleanout",
      "Impeller debris removal",
      "Lid gasket and O-ring inspection",
      "Prime check and air-leak test",
      "Motor noise and bearing inspection",
      "Variable-speed pump tuning",
    ],
    why:
      "Your pool pump is the heart of the system. A clean, properly primed pump keeps water circulating, chemicals distributed, and your monthly energy bill low.",
  },
  "green-pool-cleanup": {
    keyword: "green pool cleanup",
    intro:
      "Green pool cleanup is our signature service — we bring algae-overrun pools back to crystal clear blue in as little as 48–72 hours.",
    includes: [
      "Pool surface and equipment assessment",
      "Heavy debris and algae mat removal",
      "Triple-shock chlorination plan",
      "Phosphate remover and algaecide treatment",
      "Filter run + multiple backwashes/cleanings",
      "Final chemistry rebalance and stain treatment",
    ],
    why:
      "A green pool isn't just ugly — it's a health hazard and it eats away at your finish. Our green pool cleanup process is fast, thorough, and warrantied.",
  },
  "pool-emergency": {
    keyword: "24/7 pool emergency",
    intro:
      "Pool emergency? Call us 24/7. Storm damage, sudden equipment failure, leaks, and water-loss issues are what we do best.",
    includes: [
      "24/7 emergency phone line",
      "Same-day or next-morning response in Tampa Bay",
      "Pump failure diagnostics and repair",
      "Plumbing leak detection",
      "Post-storm debris and chemistry recovery",
      "Equipment shut-down/start-up support",
    ],
    why:
      "When your pool has a real emergency, the difference between a quick fix and an expensive disaster is who you call first. Call Tampa Bay Pool Pros.",
  },
  "chemical-balancing": {
    keyword: "pool chemical balancing",
    intro:
      "Precise pool chemical balancing keeps your water safe, comfortable, and scale-free — and protects your equipment from acid attack or scaling.",
    includes: [
      "Full panel water test",
      "Free chlorine + total chlorine adjustment",
      "pH and total alkalinity balancing",
      "Calcium hardness adjustment",
      "Stabilizer (CYA) management",
      "Salt-water pool calibration",
    ],
    why:
      "Bad pool chemistry causes itchy skin, cloudy water, stained surfaces, and equipment damage. Proper balancing fixes all of it.",
  },
  "equipment-repair": {
    keyword: "pool equipment repair",
    intro:
      "Pool equipment repair across Tampa Bay — pumps, filters, heaters, salt cells, timers, lights, and automation.",
    includes: [
      "Diagnostic visit",
      "Pump motor and seal replacement",
      "Filter housing and manifold repair",
      "Heater (gas + heat-pump) repair",
      "Salt cell cleaning and replacement",
      "Timer, controller, and automation setup",
    ],
    why:
      "We diagnose first, quote in writing, and repair on the spot when we can — no surprise charges, no part swap-shotgunning.",
  },
};
